import * as React from 'react';

import {CTABanner} from 'shells/cta-banner/cta-banner';
// @ts-expect-error - imported from .js/.jsx file
import {SiteGlobeIcon} from 'shells/icon/svg/site-globe-icon';

import {OpenableModals, useOpenableModal} from '../../openable-modals';

export function AnalyticsInfoBanner() {
    const {onOpen} = useOpenableModal(OpenableModals.ANALYTICS_ONBOARDING_MODAL);

    return (
        <CTABanner
            icon={SiteGlobeIcon}
            title='Track some of these sources automatically'
            text='Set up Nutshell Analytics to get started'
            buttonText='Learn more'
            onPrimaryAction={onOpen}
        />
    );
}
